import axios from 'axios'
import { getQiniuToken } from '@/api/public'
import { QINIU_UPLOAD_URLS, QINIU_DEFAULT_REGION, QINIU_DOMAIN } from '@/config/qiniu'

/**
 * 七牛直传：后端取上传凭证 → 直传七牛 → 返回外链 URL
 * ImageUploader / WechatEditor 等共用；业务组件只管传文件，不各自拼签名
 * @param {File|Blob} file 文件
 * @param {String} dir 存储 key 前缀（如 'activity/image'），自动去掉首尾斜杠
 * @param {Object} [opts] 可选 { region } 覆盖上传区域
 * @returns {Promise<String>} 外链 URL（token 接口下发的 domain 优先，全局域名兜底）
 */
export default function uploadToQiniu(file, dir, opts) {
  const prefix = String(dir || 'common').replace(/^\/+|\/+$/g, '')
  return getQiniuToken().then(res => {
    const conf = res.data || {}
    if (res.code !== 200 || !conf.token) {
      return Promise.reject(new Error('获取上传凭证失败'))
    }
    const rawName = (file && file.name) || 'file.bin'
    const ext = (rawName.split('.').pop() || 'bin').toLowerCase()
    const key = prefix + '/' + Date.now() + '-' + Math.random().toString(36).slice(2, 8) + '.' + ext
    const form = new FormData()
    form.append('token', conf.token)
    form.append('key', key)
    form.append('file', file)
    const region = (opts && opts.region) || QINIU_DEFAULT_REGION
    const uploadUrl = QINIU_UPLOAD_URLS[region] || QINIU_UPLOAD_URLS[QINIU_DEFAULT_REGION]
    // 直传七牛，不带业务鉴权头
    return axios.post(uploadUrl, form).then(() => {
      const domain = String(conf.domain || QINIU_DOMAIN).replace(/\/+$/, '')
      return domain ? domain + '/' + key : key
    })
  })
}
